



























import debounce from 'debounce';
import type { PropType } from '@vue/composition-api';
import { defineComponent, watch, computed, ref, onMounted } from '@vue/composition-api';
import { t } from '../../helpers/translation.helper';
import type { Field } from '../types/field';
import { FieldSource } from '../types/enums/field-source';

export default defineComponent({
  props: {
    field: {
      type: Object as PropType<Field>,
      required: true,
    },
    disabled: {
      type: Boolean,
    },
    completed: {
      type: Boolean,
    },
    fieldFocused: {
      type: Boolean,
    },
    isConnectedToCurrentRecipient: {
      type: Boolean,
    },
  },
  setup(props, { emit }) {
    const focused = ref(false);
    const inputValue = ref('');
    const inputRef = ref<HTMLInputElement>(null);

    const handleInput = (value: string) => {
      if (props.disabled) {
        return;
      }
      emit('update', value);
    };

    const debounceHandleInput: (value: string) => void = debounce(handleInput, 300);

    const watchFieldFocused = (fieldFocused: boolean) => {
      if (fieldFocused) {
        const input: HTMLInputElement = inputRef.value;
        input.focus({
          preventScroll: true,
        });
      }
    };

    watch(() => props.fieldFocused, watchFieldFocused);

    const showInput = computed(() => props.isConnectedToCurrentRecipient);

    const showRequired = computed(() => {
      if (focused.value || props.completed || props.disabled) {
        return false;
      }
      return props.field.isRequired;
    });

    const value = computed(() => {
      if (props.field.source === FieldSource.Sender) {
        return props.field.value;
      }
      return props.field.value || props.field.label || t('enter-text-here');
    });

    const placeholder = computed(() => props.field.label || t('enter-text-here'));

    const handleFocus = () => {
      focused.value = true;
      emit('focus');
    };

    const handleBlur = () => {
      focused.value = false;
      emit('blur');
    };

    onMounted(() => {
      inputValue.value = props.field.value;
    });

    return {
      focused,
      inputRef,
      inputValue,
      showInput,
      showRequired,
      value,
      placeholder,
      handleInput,
      watchFieldFocused,
      handleFocus,
      handleBlur,
      debounceHandleInput,
    };
  },
});
